var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var sendToBus = function (name, payload) {
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger(name, payload);
};
export var analyticsOverlay = function (area) {
    sendToBus('customer-loyalty.loyalty-overlay', { settings: area });
};
export var analyticsStash = function (area) {
    sendToBus('customer-loyalty.loyalty-stash', { settings: area });
};
export var analyticsClick = function (area) {
    sendToBus('customer-loyalty.loyalty-button', { settings: area });
};
var setEvent = function (eventCategory, eventInfo, payload) {
    pushEventInfo(__assign({ category: {
            primaryCategory: eventCategory,
        }, eventInfo: eventInfo }, payload));
};
export var setPageInfo = function (errorType, displayType, pageSection, errorMessage, errorCode) {
    pushPageErrorInfo({
        errorType: errorType,
        displayType: displayType,
        pageSection: pageSection,
        errorMessage: errorMessage,
        errorCode: errorCode,
    });
};
export var pushPageErrorInfo = function (pageError) {
    if (pageError && window.digitalData) {
        window.digitalData.page.error = window.digitalData.page.error || [];
        window.digitalData.page.error.push(pageError);
        setAnalytics(window.digitalData);
    }
};
export var setEditEvent = function (area, field) {
    setEvent('button submission', {
        eventName: 'my account settings',
    }, {
        myAccount: {
            settings: "".concat(area, ": ").concat(field),
        },
    });
};
export var clickCta = function (area) {
    setEvent('button submission', {
        eventName: 'my account settings',
    }, {
        myAccount: {
            settings: "".concat(area),
        },
    });
};
export var tooltipHover = function (area) {
    setEvent('tooltip', {
        eventName: area,
    });
};
var setErrorEvent = function (pageSection, errorCode, errorMessage, displayType) {
    setEvent('error', {
        eventName: 'post page error',
        error: {
            errorType: 'error',
            displayType: displayType,
            pageSection: pageSection,
            errorCode: errorCode,
            errorMessage: errorMessage,
        },
    });
};
export var pushErrorEvent = function (pageSection, displayType, errCode, errMessage) {
    if (displayType === void 0) { displayType = 'inline'; }
    setErrorEvent(pageSection, errCode, errMessage, displayType);
};
export var setStashEvent = function (eventCategory, eventInfo, eventMode, payload) {
    pushEventInfo(__assign({ category: {
            primaryCategory: eventCategory,
        }, eventInfo: eventInfo, eventMode: eventMode }, payload));
};
export var stashLinkEvent = function (action) {
    setStashEvent('stash', {
        eventName: 'my account settings',
    }, 'stash', {
        stash: { myAccount: { settings: action } },
    });
};
export var setOverlayEvent = function (eventName, payload) {
    setEvent('overlay', {
        eventName: eventName,
    }, payload);
};
/**
 * Function for updating page data in the global variable _T
 * @param digitalData - the digital data object we want to push to page data array
 * @returns undefined
 */
export var setAnalytics = function (digitalData) {
    var _ddo = digitalData.init();
    window._T = window._T || {};
    if (typeof window._T.pageData === 'undefined') {
        window._T.pageData = [];
    }
    window._T.pageData.push(_ddo);
};
/**
 * Function for updating an event array in the global variable digitalData
 * @param analyticsEvent - an event object we want to push to event array
 * @returns undefined
 */
export var pushEventInfo = function (analyticsEvent) {
    if (analyticsEvent && window.digitalData) {
        try {
            window.digitalData.event = window.digitalData.event || [];
            window.digitalData.event.push(analyticsEvent);
            setAnalytics(window.digitalData);
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error('DDO : Error in pushing the event info!!!');
        }
    }
};
/**
 * Function for setting page details in the global variable digitalData
 * @param page - an page details object we want to set in the digitalData
 * @returns undefined
 */
export function setPageDetails(page) {
    if (window.digitalData) {
        try {
            window.digitalData.page = page;
            setAnalytics(window.digitalData);
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error('DDO : Error in setting the page object and initializing it!!!');
        }
    }
}
